import { FetchAuth } from "../utils/FetchAuthUtil";

export class BannerService {
    private static endpoint = process.env.REACT_APP_API_ENDPOINT;

    public static getBanners = async (archived: boolean): Promise<any> => {
        try {
            const response = await FetchAuth(`${this.endpoint}/webcarousel/getCarousel/admin?archived=${archived}`, {
                method: "GET",
                headers: { 'Content-Type': "application/json" }
            });
            return await response.json();
        } catch (error) {
            throw error;
        }
    }

    public static getBannerById = async (id: string): Promise<any> => {
        try {
            const response = await FetchAuth(`${this.endpoint}/webcarousel/getById/${id}`, {
                method: "GET",
                headers: { 'Content-Type': "application/json" }
            });
            return await response.json();
        } catch (error) {
            throw error;
        }
    }

    public static createBanner = async (data: FormData): Promise<any> => {
        try {
            const response = await FetchAuth(`${this.endpoint}/webcarousel/create`, {
                method: "POST",
                body: data
            });
            return await response.json();
        } catch (error) {
            throw error;
        }
    }

    public static updateBanner = async (data: FormData, id: string): Promise<any> => {
        try {
            const response = await FetchAuth(`${this.endpoint}/webcarousel/update/${id}`, {
                method: "PUT",
                body: data
            });
            return await response.json();
        } catch (error) {
            throw error;
        }
    }

    public static toggleArchive = async (id: string): Promise<any> => {
        try {
            const response = await FetchAuth(`${this.endpoint}/webcarousel/toggleArchive/${id}`, {
                method: "PATCH",
                headers: { 'Content-Type': "application/json" }
            });
            return await response.json();
        } catch (error) {
            throw error;
        }
    }

    public static deleteBanner = async (id: string): Promise<string> => {
        try {
            const response = await FetchAuth(`${this.endpoint}/webcarousel/delete/${id}`, {
                method: "DELETE",
                headers: { 'Content-Type': "application/json" }
            });
            const data = await response.json();
            return data.message;
        } catch (error) {
            throw error;
        }
    }
} 